import { Price, PriceV2 } from 'types'

export enum ProductPlan {
  LIGHTEST = 'LIGHTEST',
  ESSENTIAL = 'ESSENTIAL',
  ORIGINAL = 'ORIGINAL',
  PLUS = 'PLUS',
  LIGHTEST_GO = 'LIGHTEST_GO',
  ESSENTIAL_GO = 'ESSENTIAL_GO',
  ORIGINAL_GO = 'ORIGINAL_GO',
  PLUS_GO = 'PLUS_GO',
}

export type ProductPlanPrices = Partial<Record<ProductPlan, Price>>
export type PriceV2Prices = Partial<Record<ProductPlan, PriceV2>>
